module.exports = __webpack_public_path__ + "assets/img/usericon.17e44efd.jpg";